export default __webpack_public_path__ + "static/media/userblock.235fde59.svg";